module.exports = __webpack_public_path__ + "img/window_svg_.58151928.svg";